import React, { PureComponent } from 'react';
import { object, array, oneOfType, number, string } from 'prop-types';
import {
  VictoryLine,
  VictoryAxis,
  VictoryScatter,
  VictoryVoronoiContainer,
  VictoryTooltip,
} from 'victory';
import { isDesktop, uniqBy } from 'common/utils';
import IEVictoryChart from 'common/IEVictoryChart';
import './index.css';

/**
 *
 *
 * @export
 * @class LineChart
 * @extends {PureComponent}
 */
export class LineChart extends PureComponent {
  static displayName = 'LineChart';

  static propTypes = {
    chartData: oneOfType([object, array]), // TODO: define prop properly
    width: number,
    height: number,
    unit: string,
  };

  static defaultProps = {
    width: 550,
    height: 400,
  };

  render() {
    const { chartData, width, height, unit } = this.props;
    // expecting empty state outside, but just in case
    if (!chartData.length) {
      return null;
    }

    const scatterData = chartData.filter(({ y }) => y);
    // group chartData by y numbers, sort by number in ascending
    const dataGroup = uniqBy(chartData, 'y').sort((a, b) => a.y - b.y);
    // get the max number, add 25% to keep the line below chart top
    const yPoints = [0, dataGroup[dataGroup.length - 1].y * 1.25];

    const chart = (
      <IEVictoryChart
        standalone={!!isDesktop()}
        domainPadding={10}
        width={width}
        height={height}
        scale={{ x: 'time' }}
        containerComponent={<VictoryVoronoiContainer />}
        padding={{ top: 40, bottom: 40, left: 60, right: 40 }}
      >
        <VictoryAxis
          dependentAxis
          crossAxis={false}
          standalone={false}
          tickFormat={t =>
            t
              .toFixed()
              .toString()
              .replace(/,/g, '')
          }
          style={{
            axis: { strokeOpacity: 0 },
            grid: { stroke: '#f6f6f6' },
            ticks: { stroke: 'grey', size: 0 },
            tickLabels: {
              fontSize: 14,
              padding: 15,
              fill: '#4f4f4f',
              fontFamily: '"Univers LT Roman", sans-serif',
            },
          }}
        />
        <VictoryLine
          standalone={false}
          style={{
            data: {
              stroke: '#156A34',
              strokeWidth: '1',
              strokeLinejoin: 'bevel',
            },
          }}
          data={chartData}
          domain={{ y: yPoints }}
        />
        <VictoryAxis
          style={{
            axis: { stroke: '#d4d4d4' },
            tickLabels: {
              fontSize: 14,
              padding: 15,
              fill: '#4f4f4f',
              fontFamily: '"Univers LT Roman", sans-serif',
            },
          }}
        />
        <VictoryScatter
          data={scatterData}
          size={isDesktop() ? 4 : 7}
          style={{
            data: { fill: '#156A34' },
            labels: { fontSize: 12, padding: 5 },
          }}
          labels={d => `${d.y.toFixed()} bu`}
          events={this.getEvents()}
          labelComponent={
            <VictoryTooltip
              renderInPortal
              cornerRadius={2}
              pointerLength={5}
              flyoutStyle={{
                stroke: 'black',
                fill: 'white',
              }}
            />
          }
        />
      </IEVictoryChart>
    );

    const composedChart = isDesktop() ? (
      <div className="scrollable">{chart}</div>
    ) : (
      <div className="scrollable">
        {/* Wrapping the chart in a an SVG and adding  standalone={false} fixes
          touch events on Android https://github.com/FormidableLabs/victory-native/issues/96
        */}
        <svg width={width} height={height}>
          {chart}
        </svg>
      </div>
    );

    return (
      <div className="linechart">
        {unit && <h4 className="text--label">{unit}</h4>}
        {composedChart}
      </div>
    );
  }

  /**
   *
   *
   * @memberof LineChart
   */
  getEvents = () => {
    return [
      {
        target: 'data',
        eventHandlers: {
          onClick: () => {
            return [
              {
                target: 'labels',
                mutation: () => ({ active: true }),
              },
            ];
          },
          onMouseOut: () => {
            return [
              {
                target: 'labels',
                mutation: () => ({ active: false }),
              },
            ];
          },
        },
      },
    ];
  };
}

export default LineChart;



// WEBPACK FOOTER //
// ./src/common/components/LineChart/index.js